import { useEffect, useState } from "react";
import axios from "axios";
import { Scroll, RefreshCw, Share2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DailyVerseCard = () => {
  const [verse, setVerse] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async (random = false) => {
    setLoading(true);
    try {
      const url = random ? `${API}/verses/random?faith=all` : `${API}/daily-verse`;
      const res = await axios.get(url);
      setVerse(res.data);
    } catch (e) {
      toast.error("Could not load verse.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load(false);
  }, []);

  const share = async () => {
    if (!verse) return;
    const text = `"${verse.text}"\n— ${verse.citation}\n\nvia Ask God`;
    try {
      if (navigator.share) {
        await navigator.share({ text, title: "Ask God — Daily Verse" });
      } else {
        await navigator.clipboard.writeText(text);
        toast.success("Verse copied to clipboard");
      }
    } catch {
      /* user cancelled */
    }
  };

  return (
    <div
      data-testid="daily-verse-card"
      className="relative rounded-2xl gold-border bg-[#4A0A17]/60 backdrop-blur-sm p-6 sm:p-7 fade-up"
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2 text-[#E7B04A]">
          <Scroll className="w-4 h-4" strokeWidth={1.6} />
          <span className="text-xs sm:text-sm uppercase tracking-[0.16em] font-sans-clean font-bold">
            Verse of the Day
          </span>
        </div>
        <button
          onClick={() => load(true)}
          data-testid="daily-verse-refresh-btn"
          aria-label="New verse"
          className="text-[#FBEBD3] hover:text-[#E7B04A] transition-colors p-1.5 rounded-full hover:bg-[#E7B04A]/10"
        >
          <RefreshCw className={`w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`} />
        </button>
      </div>

      {verse ? (
        <>
          <blockquote
            data-testid="daily-verse-quote"
            className="font-scripture italic text-2xl sm:text-xl leading-relaxed text-[#FFFFFF]"
          >
            &ldquo;{verse.text}&rdquo;
          </blockquote>
          <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
            <div className="text-sm font-sans-clean">
              <div className="text-[#E7B04A] font-bold text-base">{verse.citation}</div>
              <div className="text-[#FBEBD3] text-xs sm:text-[0.72rem] uppercase tracking-[0.14em] mt-0.5 font-semibold">
                {verse.tradition_label}
              </div>
            </div>
            <button
              onClick={share}
              data-testid="daily-verse-share-btn"
              className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-[#FBEBD3] hover:text-[#E7B04A] transition-colors"
            >
              <Share2 className="w-3.5 h-3.5" strokeWidth={1.6} />
              Share
            </button>
          </div>
        </>
      ) : (
        <div className="h-24 flex items-center text-[#FBEBD3] text-sm italic">
          Lighting the candle…
        </div>
      )}
    </div>
  );
};

export default DailyVerseCard;
